import { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { handleScroll } from "../util/HomeRouteHelper";

const Navbar = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="fixed top-0 left-0 z-50 w-full bg-white shadow-md">
      <div className="container flex items-center justify-between px-4 py-3 mx-auto">
        {/* Logo */}
        <img
          src="/image/logo.png"
          className="w-full cursor-pointer max-w-44"
          onClick={() => handleScroll("home")}
        />

        {/* Desktop Menu */}
        <div className="items-center hidden gap-8 md:flex">
          <a
            onClick={() => handleScroll("home")}
            className="text-gray-700 transition cursor-pointer hover:text-blue-600"
          >
            {intl.formatMessage({ id: "home" })}
          </a>
          <a
            onClick={() => handleScroll("about")}
            className="text-gray-700 transition cursor-pointer hover:text-blue-600"
          >
            {intl.formatMessage({ id: "about" })}
          </a>
          <a
            onClick={() => handleScroll("faq")}
            className="text-gray-700 transition cursor-pointer hover:text-blue-600"
          >
            {intl.formatMessage({ id: "faq" })}
          </a>
          <a
            onClick={() => handleScroll("contact")}
            className="text-gray-700 transition cursor-pointer hover:text-blue-600"
          >
            {intl.formatMessage({ id: "contact" })}
          </a>
          <button
            onClick={() => navigate("/quote/phone")}
            className="bg-[#6b5c45] border-2 border-[#3f3525] text-white px-4 py-2 rounded-full hover:bg-[#3f3525] transition cursor-pointer"
          >
            {intl.formatMessage({ id: "getQuotation" })}
          </button>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={toggleMenu}>
            {isOpen ? <FaTimes size={28} /> : <FaBars size={28} />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      {isOpen && (
        <div className="z-50 bg-white shadow-md md:hidden">
          <div className="flex flex-col items-center gap-4 py-4">
            <a
              onClick={() => handleScroll("home")}
              className="text-gray-700 transition cursor-pointer hover:text-blue-600"
            >
              {intl.formatMessage({ id: "home" })}
            </a>
            <a
              onClick={() => handleScroll("about")}
              className="text-gray-700 transition cursor-pointer hover:text-blue-600"
            >
              {intl.formatMessage({ id: "about" })}
            </a>
            <a
              onClick={() => handleScroll("faq")}
              className="text-gray-700 transition cursor-pointer hover:text-blue-600"
            >
              {intl.formatMessage({ id: "faq" })}
            </a>
            <a
              onClick={() => handleScroll("contact")}
              className="text-gray-700 transition cursor-pointer hover:text-blue-600"
            >
              {intl.formatMessage({ id: "contact" })}
            </a>
            <button
              onClick={() => navigate("/quote/phone")}
              className="bg-[#6b5c45] border-2 border-[#3f3525] text-white px-4 py-2 rounded-full hover:bg-[#3f3525] transition cursor-pointer"
            >
              {intl.formatMessage({ id: "getQuotation" })}
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
